import gql from 'graphql-tag'

export const GetFrameworkCategories = () => {
  return gql`query getFrameworkCategories($frameworkID: String!) {
      frameworkCategories(input: {frameworkID: $frameworkID}) {
        flat
				framework
        categories {
          controlNanoID
          highLevelCategoryNanoID
          lowLevelCategoryNanoID
          name
          description
          numberOfControls
          highLevelOrder
          numberOfCompliantControls
          numberOfNotApplicableControls
          safeguardID
          categories{
            name
            numberOfControls
            lowLevelOrder
            numberOfCompliantControls
            numberOfNotApplicableControls
            safeguardID
            description
            lowLevelCategoryNanoID
          }
        }
      }
    }`
}

export const GetSummary = () => {
  return gql`query getSummary{
    summary{
      frameworkSummary{
      name
      longName
      frameworkID
      active
    }
    controlSummary{
      numControlsCompliant
      numControlsNotApplicable
      numControlsAwaitingReview
      numFrameworksEnabled
      numControlsNotCompliant
      numControlsAwaitingEvidence
      totalEnabledControls
    }
    }
  }`
}

export const EnableFramework = gql`mutation enableFramework($frameworkID: String!){
    enableFramework(input: {frameworkID: $frameworkID})
  }`

export const DisableFramework = gql`mutation disableFramework($frameworkID: String!){
    disableFramework(input: { frameworkID: $frameworkID })
  }`



// WEBPACK FOOTER //
// ./src/queries/frameworks.js